<template>
  <div id="logo-wrapper">
    <router-link to="/">
      <img id="logo" src="@/assets/gk-logo-frosty.png" alt="Good Kid logo" :class="{ 'animated': animated }" />
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    animated: Boolean,
  },
};
</script>

<style scoped>
#logo-wrapper {
  position: relative;
  height: 136.96px;
}

#logo-wrapper a {
  cursor: pointer;
}
#logo {
  display: block;
  left: 0;
  right: 0;
  max-width: 200px;
  filter: drop-shadow(0px 0px 4px #888);
  border: 0;
}

#logo:hover {
  opacity: 0.95;
}

.animated {
  animation: fade-in-and-move-up 1s ease-out 0.5s forwards;
  opacity: 0;
}

@keyframes fade-in-and-move-up {
  0% {
    opacity: 0;
    top: 50px;
  }
  100% {
    opacity: 1;
    top: 0;
  }
}
</style>
